import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { IInvestmentFilter } from 'src/interfaces/mortgage-deal/investment';
import { DTO } from './base.dto';

export class FunderInvestmentFilterDTO extends DTO {
  public param: undefined;
  public query: IInvestmentFilter;
  public body: unknown;
  public url: string = ENDPOINT.FUNDER_LIST_INVESTMENT;
  public method: HTTP_METHOD = HTTP_METHOD.GET;
  constructor(query: IInvestmentFilter){
    super();
    this.query = query;
  }
}

export class GetMortgageProposalListDTO extends DTO {
  public param: {mortgageId: string};
  public query: undefined;
  public body: undefined;
  public url: string = ENDPOINT.BORROWER_LIST_PROPOSAL;
  public method: HTTP_METHOD = HTTP_METHOD.GET;
  constructor(param: {mortgageId: string}){
    super();
    this.param = param;
  }
}

export class RejectAllMortgageProposalListDTO extends DTO {
  public param: {mortgageId: string};
  public query: undefined;
  public body: undefined;
  public url: string = ENDPOINT.BORROWER_REJECT_ALL_PROPOSAL;
  public method: HTTP_METHOD = HTTP_METHOD.PUT;
  constructor(param: {mortgageId: string}){
    super();
    this.param = param;
  }
}

export class AcceptOneMortgageProposalListDTO extends DTO {
  public param: {mortgageId: string};
  public query: undefined;
  public body: {biddingId: string};
  public url: string = ENDPOINT.BORROWER_APPROVE_ONE_PROPOSAL;
  public method: HTTP_METHOD = HTTP_METHOD.PUT;
  constructor(param: {mortgageId: string}, body: {biddingId: string}){
    super();
    this.param = param;
    this.body = body;
  }
}

export class GetInvestmentDetailDTO extends DTO{
  public param: {biddingId: string};
  public query: undefined;
  public body: undefined;
  public url: string = ENDPOINT.GET_BIDDING_ID;
  public method: HTTP_METHOD = HTTP_METHOD.GET;
  constructor(param: {biddingId: string}){
    super();
    this.param = param;
    
  }
}